import { ID } from 'shared/types/id';
import { InheritColors } from 'shared/types/inherit-colors';
import { LifeArea } from 'shared/types/life-area';

type Options = {
  goals: {
    id: ID;
    parentIds?: ID[] | null;
    lifeAreaId?: ID | null;
    color?: string | null;
  }[];
  lifeAreas: LifeArea[];
  usedIds?: Set<ID>;
};

export const getLinkedItemColor = (
  linkedItemId: ID,
  { lifeAreas, goals, usedIds }: Options,
): string | null => {
  const _usedIds = usedIds ?? new Set();
  // to prevent loops we cancel out when revisiting a used ID
  if (_usedIds.has(linkedItemId)) {
    return null;
  }
  _usedIds.add(linkedItemId);

  const goal = goals.find(({ id }) => id === linkedItemId);
  const lifeArea = goal
    ? undefined
    : lifeAreas.find(({ id }) => id === linkedItemId);

  if (goal?.color === InheritColors.Goal) {
    const parentId = goal.parentIds?.[goal.parentIds.length - 1];
    if (!parentId) {
      return null;
    }

    return getLinkedItemColor(parentId, {
      lifeAreas,
      goals,
      usedIds: _usedIds,
    });
  }

  if (goal?.color === InheritColors.LifeArea) {
    const lifeArea = lifeAreas.find(({ id }) => id === goal.lifeAreaId);
    if (!lifeArea) {
      return null;
    }

    return lifeArea.color ?? null;
  }

  if (goal?.color) {
    return goal.color ?? null;
  }

  return lifeArea?.color ?? null;
};
